import React from 'react';
import { Button } from '../UI/Button';
import { Link } from 'react-router-dom';
export const TrainingCTA = () => {
  const scrollToForm = () => {
    const formSection = document.getElementById('training-proposal-form');
    if (formSection) {
      formSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-24 bg-navy relative overflow-hidden" data-id="element-1192" data-mp="1khwdwpur06a2">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-primary rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse-soft" data-id="element-1193" data-mp="1pf607wmuc1to"></div>
      <div className="absolute bottom-0 right-0 w-64 h-64 bg-gold rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse-soft" style={{
      animationDelay: '1s'
    }} data-id="element-1194" data-mp="1z4pl17u465r6"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-1195" data-mp="286fl1222ad0k">
        <div className="max-w-4xl mx-auto text-center scroll-animate" data-id="element-1196" data-mp="283uieatxvt1r">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 font-heading" data-id="element-1197" data-mp="2d5s4dctq51ye">
            Let's Build Smarter Teams Together
          </h2>
          <p className="text-xl md:text-2xl text-gray-300 mb-12 font-sans" data-id="element-1198" data-mp="nr4h9o5b0htw">
            Equip your people with the skills they need to thrive in the modern
            world.
          </p>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-6" data-id="element-1199" data-mp="dtq0fnfgxr12">
            <Button size="large" className="w-full sm:w-auto text-lg px-8 py-4 shadow-lg hover:shadow-primary/25" onClick={scrollToForm} data-id="element-1200" data-mp="1bgysy2dw00ck">
              Book a Training
            </Button>

            <Button variant="outline" size="large" className="w-full sm:w-auto text-lg px-8 py-4 border-white text-white hover:bg-white/10" onClick={scrollToForm} data-id="element-1201" data-mp="11rf8wtefu0g4">
              Request Proposal
            </Button>

            <Link to="/partner-with-us" className="w-full sm:w-auto" data-id="element-1202" data-mp="1u7g9z9pcx7i3">
              <Button variant="outline" size="large" className="w-full text-lg px-8 py-4 border-white text-white hover:bg-white/10" data-id="element-1203" data-mp="1u9j70doxg0wb">
                Partner With Us
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
};